import { PROVIDERS, type ProviderSource } from '../constants/providers';

const providerSourceSet = new Set<string>(PROVIDERS);

export function isProviderSource(value: string): value is ProviderSource {
  return providerSourceSet.has(value);
}

export function toProviderSource(value: string | null | undefined): ProviderSource | null {
  if (typeof value !== 'string' || !isProviderSource(value)) return null;
  return value;
}
